<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        v-on="on"
      >
        Create Separation Type
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Separation Type"
      text="Create Separation Type"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                outlined
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: false,
        name: '',
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.resetForm()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.progressing = true

          this.$api.hrisSeparationTypes().create({
            name: this.name,
          })
            .then(response => {
              this.$emit('created', response.data)
              this.$snack({ message: 'Added new separation type' })

              this.dialog = false
            })
            .catch((err) => {
              if (err.response.status === 500) {              
                this.$snack({ 
                  color: 'error',
                  message: err.response.data.status, 
                })
              }            
            
              this.progressing = false
            })    
            .then(() => {
              this.progressing = false
            })
        })
      },
      resetForm () {
        this.name = ''
        this.$validator.reset()
      },
    },
  }
</script>
